var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Misc-/-Radio-Button-/-On-#1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Radio-Button"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u2B1B-Background",
    fill: "#FC686F",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD83D\\uDD35-Oval",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleMessages);
export default __webpack_public_path__ + "static/media/circle-messages.5cc0b3192ea0438a91fe5488bb511ea2.svg";
export { ForwardRef as ReactComponent };